<template>
    <v-dialog 
        v-model="dialogPassword"
        :transition="'none'" 
        class="dialogPassword"
        :scroll-strategy="'none'">
        <v-card flat class="pt-3 pb-3">
            <v-row class="w-100 align-center justify-end">
                <v-col cols="auto">
                    <ExitButton @click="dialogPassword=false"/>
                </v-col>
            </v-row>

            <v-row dense class="w-100 align-center justify-begin mt-n8">
                <v-col cols="auto">
                    <v-card-title>Information</v-card-title>
                </v-col>
            </v-row>

            <v-row dense class="w-100 align-center justify-center mt-n2 mb-2">
                <v-col cols="auto">
                    <v-card-subtitle>
                        Sind Sie sicher, dass Sie Ihr Passwort ändern wollen?<br>
                        Dieser Vorgang kann nicht rückgängig gemacht werden!
                    </v-card-subtitle>
                </v-col>
            </v-row>

            <v-row class="justify-end w-100 mt-n4">
                <v-col cols="auto">
                    <v-card-actions>
                        <v-btn 
                            @click="confirmPassword"
                            prepend-icon="mdi-pencil" 
                            variant="elevated" 
                            color="red">
                            Passwort ändern
                        </v-btn>
                        <v-btn 
                            @click="dialogPassword=false" 
                            variant="elevated" 
                            color="grey">
                            Abbrechen
                        </v-btn>
                    </v-card-actions>
                </v-col>
            </v-row> 
        </v-card>
    </v-dialog>

    <SnackbarPassword ref="snackbarPasswordRef" />
</template>

<script>
import ExitButton from '../consumables/ExitButton.vue';
import SnackbarPassword from '../consumables/SnackbarPassword.vue';

export default {
    components:{
        SnackbarPassword,
        ExitButton
    },

    props: {
        pwDialogOld: { type: String, required: true },
        pwDialogNew: { type: String, required: true }
    },

    data() {
        return {
            dialogPassword: false
        }
    },

    methods: {
        openDialogPassword() {
            this.dialogPassword = true
        },

        async confirmPassword() {
            try {
                await this.$axios.patch('/api/users/change-password/', {
                    old_password: this.pwDialogOld,
                    new_password: this.pwDialogNew
                })

                // Dialog schließen
                this.dialogPassword = false

                // Erfolg anzeigen
                this.$refs.snackbarPasswordRef.show('Passwort erfolgreich geändert.', 'green')

                // *** Token löschen – Benutzer sauber abmelden ***
                localStorage.removeItem('access_token')
                delete this.$axios.defaults.headers.common['Authorization']

                // Kurze Verzögerung + Redirect
                setTimeout(() => {
                    this.$router.push({ name: 'Auth' })
                }, 700)

            } catch (error) {
                const message = error.response?.data?.error || 'Fehler beim Ändern des Passworts'
                this.$refs.snackbarPasswordRef.show(message, 'red')
            }
        }
    }
}
</script>

<style scoped>
.dialogPassword{
    width: 600px;
    max-height: none;
    overflow-y: visible !important;
}
</style>
